import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { LayoutCell, PluginHelper, useFindLayoutCell, } from "@plansoft-configuration-renderer/layout";
/**
 * Renders current tab from child layout
 * @category UI
 * @param props
 * @returns
 */
export function ConfigurationTabsContent(props) {
    const tabNode = useFindLayoutCell((data) => {
        const pluginProps = PluginHelper.getPluginProps(data);
        return pluginProps.tabId === props.activeTab;
    });
    if (!tabNode) {
        return _jsx(Fragment, {});
    }
    return _jsx(LayoutCell, { node: tabNode });
}
//# sourceMappingURL=ConfigurationTabsContent.js.map